import { Css, PreventBrowserScroll, ScrollableParent } from "@homebound/beam";
import { PropsWithChildren } from "react";
import { ZendeskWidget } from "src/components/ZendeskWidget";
import { useLoggedInAppSetup } from "src/hooks/useLoggedInAppSetup";
import { useMatchAny } from "src/hooks/useMatchAny";
import { GlobalNav } from "src/routes/layout/global-nav/GlobalNav";
import { LoggedInPageWrapper } from "src/routes/layout/LoggedInPageWrapper";
import {
  adminPaths,
  changeLogPaths,
  developmentPaths,
  librariesPath,
  personalDashboardPaths,
  projectPaths,
  tradeCategoryLeadTimesPath,
  warrantyPaths,
} from "src/routes/routesDef";
import { AppProviders } from "src/routing/components/AppProviders";

export type PageLayoutProps = PropsWithChildren;

/**
 * LEGACY ROUTING — logged-in layout for URLs that fall through `Router.tsx` to `App`.
 * Migrated domains use `AppShell` + `components/layouts/` instead. See `src/routing/README.md`.
 */
export function PageLayout(props: PageLayoutProps) {
  useLoggedInAppSetup();

  // We want two separate top level layouts whether you are in a Project/Development/Libraries specific path or not.
  // This makes styling with the side nav easier if we do not need to nest ScrollableParent containers.
  const hasOwnLayout = useMatchAny([
    projectPaths.project,
    developmentPaths.development,
    adminPaths.admin,
    librariesPath,
    personalDashboardPaths.dashboard,
    tradeCategoryLeadTimesPath,
    changeLogPaths.base,
    warrantyPaths.details,
  ]);

  const content = hasOwnLayout ? (
    props.children
  ) : (
    <ScrollableParent tagName="main" px={3} xss={Css.bgGray100.$}>
      {props.children}
    </ScrollableParent>
  );

  return (
    <AppProviders>
      <ZendeskWidget />
      <PreventBrowserScroll>
        <GlobalNav />
        <LoggedInPageWrapper>{content}</LoggedInPageWrapper>
      </PreventBrowserScroll>
    </AppProviders>
  );
}
